import React, { useCallback } from 'react';
import { usePrintDispatch, WidgetHeader } from '@mummssoftware/common-ui';
import type { PrintProgress } from '@mummssoftware/utils/api/Printing';

type CrossPatientIdgPrintFaxHandlerProps = {
  appTitle?: string;
  versionInfo: string;
  smallWidget?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  doNotShow?: boolean;
  hasSelection: boolean;
  getPrintPromise: (
    faxInstructions: any,
    emailInstructions: any,
  ) => Promise<unknown>;
  setFetchingPdf: (v: boolean) => void;
  setPrintProgress: (p: PrintProgress | null) => void;
  showPrint: boolean;
};

export const CrossPatientIdgPrintFaxHandler = ({
  appTitle,
  versionInfo,
  smallWidget,
  onClick,
  onRemove,
  doNotShow,
  hasSelection,
  getPrintPromise,
  setFetchingPdf,
  setPrintProgress,
  showPrint,
}: CrossPatientIdgPrintFaxHandlerProps) => {
  const onBefore = useCallback(() => setFetchingPdf(true), [setFetchingPdf]);
  const onAfter = useCallback(() => {
    setPrintProgress(null);
    setFetchingPdf(false);
  }, [setPrintProgress, setFetchingPdf]);

  const { print, fax, email } = usePrintDispatch(
    getPrintPromise,
    onBefore,
    onAfter,
  );

  const guardedPrint = useCallback(() => {
    if (hasSelection) print();
  }, [hasSelection, print]);
  const guardedFax = useCallback(() => {
    if (hasSelection) fax();
  }, [hasSelection, fax]);
  const guardedEmail = useCallback(() => {
    if (hasSelection) email();
  }, [hasSelection, email]);

  return (
    <WidgetHeader
      appTitle={appTitle ?? ''}
      versionInfo={versionInfo}
      smallWidget={smallWidget}
      onPrint={guardedPrint}
      onFax={guardedFax}
      onEmail={guardedEmail}
      showPrint={showPrint}
      showFax={showPrint}
      disablePrint={!hasSelection}
      onClick={onClick}
      onRemove={onRemove}
      doNotShow={doNotShow}
    />
  );
};
